var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-qa-detail" }, [
    _c("div", { staticClass: "header" }, [
      _c("img", { attrs: { src: _vm.ossPondHost + "img/xiazeng_icon.png" } }),
      _c("div", { staticClass: "header-num" }, [
        _vm._v("虾罾编号 "),
        _c("span", [_vm._v(_vm._s(_vm.info.uniqueId))])
      ]),
      _c("div", { staticClass: "header-num" }, [
        _vm._v("imei "),
        _c("span", [_vm._v(_vm._s(_vm.info.imei ? _vm.info.imei : "--"))])
      ]),
      _c("div", { staticClass: "header-num" }, [
        _vm._v("iccid "),
        _c("span", [_vm._v(_vm._s(_vm.info.iccid ? _vm.info.iccid : "--"))])
      ])
    ]),
    _c("div", { staticClass: "body" }, [
      _vm._m(0),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "item-label" }, [_vm._v("远程打样测试")]),
        _c("div", { staticClass: "item-value" }, [
          _vm.info.testSample == 1
            ? _c(
                "span",
                {
                  staticClass: "view-media",
                  on: { click: _vm.openMediaModal }
                },
                [_vm._v("查看视频和照片")]
              )
            : _c("span", [_vm._v("未完成")])
        ])
      ]),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "item-label" }, [_vm._v("手动按键测试")]),
        _c("div", { staticClass: "item-value" }, [
          _vm._v(_vm._s(_vm.info.testBtn == 1 ? "已完成" : "未完成"))
        ])
      ]),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "item-label" }, [_vm._v("信号强度测试")]),
        _c("div", { staticClass: "item-value" }, [
          _vm._v(_vm._s(_vm.info.signalQualified == 1 ? "已完成" : "未完成"))
        ])
      ]),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "item-label" }, [_vm._v("操作人")]),
        _c("div", { staticClass: "item-value" }, [
          _vm._v(_vm._s(_vm.info.operationName))
        ])
      ]),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "item-label" }, [_vm._v("提交时间")]),
        _c("div", { staticClass: "item-value on" }, [
          _c("div", [_vm._v(_vm._s(_vm.info.submitDate))]),
          _c("div", [_vm._v(_vm._s(_vm.info.submitHour))])
        ])
      ])
    ]),
    _vm.showMediaModal
      ? _c(
          "div",
          {
            staticClass: "media-modal",
            on: {
              touchmove: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c("div", { staticClass: "media-box" }, [
              _vm.currentIndex === 0 && _vm.videoUrl
                ? _c("video", {
                    ref: "mediaVideo",
                    attrs: {
                      controls: "",
                      playsinline: "",
                      "webkit-playsinline": "",
                      src: _vm.videoUrl,
                      poster: _vm.picUrl
                    }
                  })
                : _c("img", {
                    attrs: { src: _vm.picUrl },
                    on: {
                      click: function($event) {
                        _vm.showPreviewImg = true
                      }
                    }
                  })
            ]),
            _vm.picUrl
              ? _c("div", { staticClass: "media-list" }, [
                  _c(
                    "div",
                    {
                      staticClass: "item",
                      class: { active: _vm.currentIndex === 0 },
                      on: {
                        click: function($event) {
                          return _vm.changeMediaIndex(0)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "img-box" }, [
                        _c("img", { attrs: { src: _vm.picUrl } }),
                        _c("div", { staticClass: "play-icon" })
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "item",
                      class: { active: _vm.currentIndex === 1 },
                      on: {
                        click: function($event) {
                          return _vm.changeMediaIndex(1)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "img-box" }, [
                        _c("img", { attrs: { src: _vm.picUrl } })
                      ])
                    ]
                  )
                ])
              : _c("div", { staticClass: "media-empty" }, [
                  _vm._v("未获取到视频和照片")
                ]),
            _c("img", {
              staticClass: "close-btn",
              attrs: {
                src:
                  "https://static.yudada.com/wechat/pond/img/icon_close_modal.png"
              },
              on: { click: _vm.closeMediaModal }
            }),
            _vm.showPreviewImg
              ? _c(
                  "div",
                  {
                    staticClass: "preview-mask",
                    on: {
                      click: function($event) {
                        _vm.showPreviewImg = false
                      }
                    }
                  },
                  [_c("img", { attrs: { src: _vm.picUrl } })]
                )
              : _vm._e()
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "item-label" }, [_vm._v("匹配编号，下发配置")]),
      _c("div", { staticClass: "item-value" }, [_vm._v("已完成")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }